import React, { useState } from 'react';
import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { loginAction } from '../store/authSlice';

export default function Login() {
  const dispatch = useDispatch();
  const { loading, error } = useSelector((s) => s.auth);
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (phone && password) dispatch(loginAction({ phone, password }));
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, #0d0d1a 0%, #111128 100%)',
    }}>
      <Card style={{ width: 400, background: '#1a1a2e', border: '1px solid #333' }}>
        <Card.Body className="p-4">
          <div className="text-center mb-4">
            <i className="bi bi-shield-check" style={{ fontSize: 48, color: '#00e676' }}></i>
            <h3 style={{ color: '#00e676', fontWeight: 800, marginTop: 8 }}>YEBELA</h3>
            <p style={{ color: '#888', fontSize: 13 }}>Centrale de Supervision</p>
          </div>

          {error && <Alert variant="danger" className="py-2" style={{ fontSize: 13 }}>{error}</Alert>}

          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Control
                type="text"
                placeholder="Numéro de téléphone"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                style={{ background: '#0d0d1a', border: '1px solid #333', color: '#fff' }}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Control
                type="password"
                placeholder="Mot de passe"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={{ background: '#0d0d1a', border: '1px solid #333', color: '#fff' }}
              />
            </Form.Group>
            <Button
              type="submit"
              className="w-100"
              disabled={loading}
              style={{ background: '#00e676', border: 'none', color: '#000', fontWeight: 700 }}
            >
              {loading ? 'Connexion...' : 'SE CONNECTER'}
            </Button>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
}
